import { faker } from "@faker-js/faker";

const bookingsListMock: any[] = [];

function generateBookingsList(){
  return{
    id: faker.string.numeric({ length: { min: 1, max: 5 } }),
    reference: faker.string.numeric({ length: 5 }),
    office: faker.helpers.arrayElement(['Finca de la Dehesa', 'Cangas de Onís', 'Ribadesella','Coviella' ]),
    date: faker.date.between({ from: '2024-01-01T00:00:00.000Z', to: '2024-12-31T00:00:00.000Z' }),
    service: faker.helpers.arrayElement(['Descenso Sella', 'Parque Aventura', 'Rafting', 'Paintball', 'Senderismo', 'Espeleología','Barranquismo', 'Rutas en Buggie', 'Rutas a Caballo', 'Motos de agua']),
    time_service: faker.helpers.arrayElement(['9:30', '10:00','10:30', '11:00','11:30','12:00', '12:30', '13:00', '13:30', '15:30', '16:00','16:30']),
    time_duration: faker.number.int({min: 1, max: 4}),
    status_booking: faker.helpers.arrayElement(['RESERVA 25%', 'PAGADO', 'ANULADA']),
    seats: faker.number.int({min: 1, max: 15}),
    name: faker.person.fullName(),
    vat: faker.string.numeric({length: 8 }),
    email: faker.internet.email(),
    phone: faker.phone.number('###-###-###'),
    address: faker.location.streetAddress(),
    total_amount: faker.finance.amount({min: 15 ,max: 300, dec: 2, symbol: '', autoFormat: false}),
    notes: ['casco niño', 'teléfono nuevo'],

  };
}
for (let i = 0; i < 50; i++) {
  const order = generateBookingsList();
  bookingsListMock.push(order);
}



export { bookingsListMock };
